import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import { useNavigate } from "react-router-dom";

/**
 * One headline number.
 *
 * The whole card is clickable and takes the user to the list screen that holds
 * the detail behind the number, so the dashboard is a starting point for work
 * and not just a poster.
 */
const StatCard = ({
  title,
  value,
  hint,
  icon,
  color = "primary",
  to,
  loading = false,
}) => {
  const navigate = useNavigate();

  const open = () => {
    if (to) navigate(to);
  };

  return (
    <Col xl={3} md={6}>
      <Card
        className={`h-100 ${to ? "stat-card-clickable" : ""}`}
        onClick={open}
        role={to ? "button" : undefined}
        tabIndex={to ? 0 : undefined}
        onKeyDown={(e) => {
          if (to && (e.key === "Enter" || e.key === " ")) {
            e.preventDefault();
            open();
          }
        }}
      >
        <CardBody className="d-flex align-items-center">
          <div
            className={`stat-card-icon bg-${color}-subtle text-${color} me-3`}
          >
            <i className={`${icon} font-size-24`} />
          </div>

          <div className="flex-grow-1 overflow-hidden">
            <p className="text-muted text-uppercase font-size-11 mb-1 text-truncate">
              {title}
            </p>

            {loading ? (
              <span className="stat-card-skeleton d-block" />
            ) : (
              <h3 className="mb-0 fw-bold">{value}</h3>
            )}

            {hint && (
              <small className="text-muted d-block text-truncate mt-1">
                {hint}
              </small>
            )}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default StatCard;
